export const educationData = [
    {
        id: 1,
        institution: 'NED University of Engineering and Technology',
        course: 'Bachelor of Science in Computer Science',
        startYear: '2020',
        endYear: '2024'
    }
]